import { ProjectsView } from "@components/view/projects-view";

export function ProjectsPage() {
  return <ProjectsView />;
}

